import { FilterModel, FilterType, OperatorFilterEnum } from 'features/common/types';

export const QUICK_FILTER_KEYS = ['fantasyName', 'businessName', 'rut'];

export const advancedListFilters: FilterModel[] = [
	{
		label: 'Nombre fantasía',
		type: FilterType.STRING,
		key: 'fantasyName',
		operator: OperatorFilterEnum.CONTAINS,
	},
	{
		label: 'Razón social',
		type: FilterType.STRING,
		key: 'businessName',
		operator: OperatorFilterEnum.CONTAINS,
	},
	{
		label: 'RUT',
		type: FilterType.STRING,
		key: 'rut',
		operator: OperatorFilterEnum.CONTAINS,
	},
	{
		label: 'Email',
		type: FilterType.STRING,
		key: 'email',
		operator: OperatorFilterEnum.CONTAINS,
	},
	{
		label: 'Teléfono',
		type: FilterType.STRING,
		key: 'phone',
		operator: OperatorFilterEnum.CONTAINS,
	},
	{
		label: 'Código de país',
		type: FilterType.STRING,
		key: 'countryCode',
		operator: OperatorFilterEnum.EQUALS,
	},
	{
		label: 'País',
		type: FilterType.STRING,
		key: 'countryName',
		operator: OperatorFilterEnum.CONTAINS,
	},
	{
		label: 'Estado / Provincia',
		type: FilterType.STRING,
		key: 'stateName',
		operator: OperatorFilterEnum.CONTAINS,
	},
	{
		label: 'Ciudad',
		type: FilterType.STRING,
		key: 'cityName',
		operator: OperatorFilterEnum.CONTAINS,
	},
	{
		label: 'Dirección',
		type: FilterType.STRING,
		key: 'street',
		operator: OperatorFilterEnum.CONTAINS,
	},
	{
		label: 'Código postal',
		type: FilterType.STRING,
		key: 'postalCode',
		operator: OperatorFilterEnum.CONTAINS,
	},
	{
		label: 'Activo',
		type: FilterType.BOOLEAN,
		key: 'enable',
	},
	{
		label: 'Tiene regla de fecha de pago',
		type: FilterType.BOOLEAN,
		key: 'hasPaymentDateRule',
	},
];
